import { render, staticRenderFns } from "./ClinicGateway.vue?vue&type=template&id=5a5803fe&scoped=true"
import script from "./ClinicGateway.vue?vue&type=script&setup=true&lang=js"
export * from "./ClinicGateway.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ClinicGateway.vue?vue&type=style&index=0&id=5a5803fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5803fe",
  null
  
)

export default component.exports